import React from "react";
import { PageWrapper } from "../../Styles/style";
import styled from "@emotion/styled";
import LockerMenu from "../../Components/LockerMenu";
import Header from "../../Components/Sections/S1-Header";
import About from "../../Components/Sections/S2-About";
import Browsing from "../../Components/Sections/S3-Browsing";
import Adblocker from "../../Components/Sections/S4-AdBlocker";
import IOS from "../../Components/Sections/S5-IOS";
import FAQ from "../../Components/Sections/S6-FAQ";
import Footer from "../../Components/Sections/S7-Footer";



const MainPage = () => {
  return (
    <PageWrapper>
      <LockerMenu/>
      <Header/>
      <About/>
      <Browsing/>
      <Adblocker/>
      <IOS/>
      <FAQ/>
      <Footer/>
    </PageWrapper>
  );
};

export default MainPage;
